import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: 'https://auth.nutrikator.com',
    realm: 'test-realm',
    clientId: 'test-client'
});

export default keycloak;